import React, { Component } from 'react'
import PropTypes from 'prop-types'
import transitions from './transitions'

import * as Constants from '../../../helpers/Constants'

function getStyles(props, context, state) {
  const { selectedYear, height } = state
  const isLandscape = props.mode === 'landscape'
  const lineHeight = height * 0.04 + 'px'
  const styles = {
    root: {
      width: '100%',
      height: height * 0.13,
      float: isLandscape ? 'left' : 'none',
      backgroundColor: Constants.WHITE_LABEL.colors.calendar.header,
      fontWeight: 700,
      display: 'inline-block',
      borderTopLeftRadius: 4,
      borderTopRightRadius: isLandscape ? 0 : 4,
      borderBottomLeftRadius: isLandscape ? 4 : 0,
      color: '#fff',
      padding: height * 0.027,
      boxSizing: 'border-box'
    },
    monthDay: {
      display: 'block',
      fontSize: height * 0.046,
      lineHeight: lineHeight,
      height: height * 0.039,
      opacity: selectedYear ? 0.7 : 1,
      transition: transitions.easeOut(),
      width: '100%',
      fontWeight: '500'
    },
    monthDayTitle: {
      cursor: !selectedYear ? 'default' : 'pointer',
      width: '100%',
      display: 'block'
    },
    year: {
      margin: 0,
      fontSize: height * 0.02,
      fontWeight: '500',
      lineHeight: '16px',
      height: height * 0.03,
      opacity: selectedYear ? 1 : 0.7,
      transition: transitions.easeOut()
    },
    yearTitle: {
      cursor: props.disableYearSelection || selectedYear ? 'default' : 'pointer'
    }
  }

  return styles
}

class DateDisplay extends Component {
  static propTypes = {
    DateTimeFormat: PropTypes.func.isRequired,
    disableYearSelection: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    mode: PropTypes.oneOf(['portrait', 'landscape']),
    monthDaySelected: PropTypes.bool,
    onClickMonthDay: PropTypes.func,
    onClickYear: PropTypes.func,
    selectedDate: PropTypes.object.isRequired,
    style: PropTypes.object
  }

  static defaultProps = {
    disableYearSelection: false,
    monthDaySelected: true
  }

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  }

  state = {
    selectedYear: false,
    transitionDirection: 'up',
    height: window.innerHeight
  }

  componentWillMount() {
    window.addEventListener('resize', () =>
      this.setState({ height: window.innerHeight })
    )
    if (!this.props.monthDaySelected) {
      this.setState({ selectedYear: true })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedDate !== this.props.selectedDate) {
      const direction =
        nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down'
      this.setState({
        transitionDirection: direction
      })
    }

    if (nextProps.monthDaySelected !== undefined) {
      this.setState({
        selectedYear: !nextProps.monthDaySelected
      })
    }
  }

  handleClickMonthDay = () => {
    if (this.props.onClickMonthDay && this.state.selectedYear) {
      this.props.onClickMonthDay()
    }

    this.setState({ selectedYear: false })
  }

  handleClickYear = () => {
    if (
      this.props.onClickYear &&
      !this.props.disableYearSelection &&
      !this.state.selectedYear
    ) {
      this.props.onClickYear()
    }

    if (!this.props.disableYearSelection) {
      this.setState({ selectedYear: true })
    }
  }

  render() {
    const {
      DateTimeFormat,
      disableYearSelection, // eslint-disable-line no-unused-vars
      locale,
      mode, // eslint-disable-line no-unused-vars
      monthDaySelected, // eslint-disable-line no-unused-vars
      onClickMonthDay, // eslint-disable-line no-unused-vars
      onClickYear, // eslint-disable-line no-unused-vars
      selectedDate, // eslint-disable-line no-unused-vars
      style,
      ...other
    } = this.props

    const styles = getStyles(this.props, this.context, this.state)

    const year = new DateTimeFormat(locale, {
      year: 'numeric'
    }).format(selectedDate)

    const dateTime = new DateTimeFormat(locale, {
      month: 'short',
      weekday: 'short',
      day: '2-digit'
    }).format(selectedDate)

    return (
      <div {...other} style={styles.root}>
        <div key={year} style={styles.yearTitle} onClick={this.handleClickYear}>
          {year}
        </div>
        <div
          key={dateTime}
          onClick={this.handleClickMonthDay}
          style={styles.monthDayTitle}
        >
          {dateTime}
        </div>
      </div>
    )
  }
}

export default DateDisplay



// WEBPACK FOOTER //
// ./src/components/common/calendar/DateDisplay.js